import { render, staticRenderFns } from "./DashboardCommercialCommissioners.vue?vue&type=template&id=2754c9c8"
import script from "./DashboardCommercialCommissioners.vue?vue&type=script&lang=js"
export * from "./DashboardCommercialCommissioners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports